import { useState } from "react";

import { Colors } from "@blueprintjs/core";
import Select from "react-select";

import { Box } from "@/components/layout/flexbox";
import { ProgramCard } from "@/components/pages_logged_in/program/components/ProgramCard";
import { TimelineView } from "@/components/pages_logged_in/program/components/program-timeline/TimelineView";
import { ComponentStatus } from "@/graphql";
import { LeadComponent, ParticipantComponent } from "@/types/programs";

import { TimelineMode } from "./types";

const TIMELINE_MODE_OPTIONS: {
  value: TimelineMode;
  label: string;
}[] = [
  {
    value: "month",
    label: "View months",
  },
  {
    value: "day",
    label: "View days",
  },
];

interface ProgramTimelineProps {
  programId: string;
  components: LeadComponent[] | ParticipantComponent[];
}

export function ProgramTimeline({
  programId,
  components,
}: ProgramTimelineProps) {
  const [viewMode, setViewMode] = useState(TIMELINE_MODE_OPTIONS[0]);

  if (components.length === 0) {
    return null;
  }

  const activeComponents = components.filter(
    (component) =>
      component.status !== ComponentStatus.InDesign &&
      component.targetStartDate !== null,
  );

  if (activeComponents.length === 0) {
    return null;
  }

  return (
    <Box flex={1} mb={24} css={{ background: Colors.WHITE }} width="100%">
      <ProgramCard
        title="Program Timeline"
        defaultVisible={true}
        contentPadding={0}
        hasStatusIcon={false}
        titleClassName="program-card-header mini-item"
        actionView={
          <Box
            width={160}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Select
              isLoading={false}
              value={viewMode}
              onChange={(value) => {
                if (value) {
                  setViewMode(value);
                }
              }}
              isSearchable={true}
              options={TIMELINE_MODE_OPTIONS}
              hideSelectedOptions={true}
              closeMenuOnSelect={true}
            />
          </Box>
        }
        isChildrenBelow
        canCollapse={false}
      >
        <TimelineView
          programId={programId}
          components={activeComponents}
          viewMode={viewMode.value}
          onViewModeChange={(value) => {
            const option = TIMELINE_MODE_OPTIONS.find(
              (option) => option.value === value,
            );
            if (option) {
              setViewMode(option);
            }
          }}
        />
      </ProgramCard>
    </Box>
  );
}
